module.exports = __webpack_public_path__ + "media/assets/images/flags/il-04d6335e2c1da9786f77440fd187b5ef.svg";